
import React from 'react';
import '../styles/Page.css';
import '../styles/Contact.css';

function Contact() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="glitch" data-text="Contact">Contact</h1>
        <div className="page-card">
          <p>For inquiries, collaborations, or bookings, please use the form below.</p>
          <form className="contact-form">
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <textarea placeholder="Your Message" rows="6" required></textarea>
            <button type="submit" className="btn-glitch">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
